import { Component, OnInit } from '@angular/core';
import {UserInfo} from "../models/usermaster";
import {UsermasterService} from "../services/usermaster.service";
import {ActivatedRoute} from "@angular/router";
import { Lightbox } from 'angular2-lightbox';


@Component({
  selector: 'app-userview',
  templateUrl: './userview.component.html',
})
export class UserviewComponent implements OnInit {
    
    _album: Images[] = [];

    constructor(private _lightbox: Lightbox,
        private userService:UsermasterService,
        private activatedRoute: ActivatedRoute) {
    
        console.log("test11q")
            // const src = 'https://upload.wikimedia.org/wikipedia/commons/c/c9/Moon.jpg';     
        const src = 'https://firebasestorage.googleapis.com/v0/b/firebase-cheattrap.appspot.com/o/CheatTrapImage%2F76%2F20180331161144.jpg?alt=media&token=d4629bfb-1f90-4959-b8a5-f546f8abeae4';
        const caption = 'caption here';
        const thumb = 'https://firebasestorage.googleapis.com/v0/b/firebase-cheattrap.appspot.com/o/CheatTrapImage%2F76%2F20180331161144.jpg?alt=media&token=d4629bfb-1f90-4959-b8a5-f546f8abeae4';
        const album = {
            src: src,
            caption: caption,
            thumb: thumb
        };
        
        this._album.push(album);
    }

    open(index: number): void {
        // open lightbox
        this._lightbox.open(this._album, index);
    }

    userinfo:UserInfo;
    
    ngOnInit() {
        this.getUserInfo()
    }
    getUserInfo=function () {
        this.activatedRoute.params.subscribe(params => {
            let iUserId = params['id'];
            console.log("UserId======>",iUserId); // Print the parameter to the console.
            this.userService.getUserInfo(iUserId).then(data => {
                console.log("UserInfo=======>",data['data']);
                this.userinfo = data['data'];
                this.userinfo.socialmediaimages =  this.userinfo.socialmediaimages.split(",");
                console.log("UserInfo=======>",this.userinfo.socialmediaimages);

            });
        });

    }
}

export class Images {
    // id: string;
    src: string;
    caption: string;
    thumb: string;
  }


// WEBPACK FOOTER //
// /home/sotsys211/work/src/ecard_new/backend/src/app/usermaster/userview/userview.component.ts